import React from "react";
import { withRouter } from "react-router-dom";

import "./styles.scss";

class Step1 extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        window.scrollTo(0,0);
    }

    renderSection1() {
        return (
            <div className="Section1Wrapper">
                <h1>Where to get Cardano</h1>
                <p>
                    First things first, you will need to get Cardano, also known as, ADA. Getting ADA is the same as getting any other form of currency like USD, EUR, AUD, etc. You
                    will need to make an exchange from your native FIAT currency to the cryptocurrency needed (Cardano).
                </p>
                <p>
                    Like any other form of currency trade, you will need to to this on an exchange. There are a ton of FIAT to CRYPTO exchanges out there and you have one in mind
                    then go ahead and you purchase you ADA through them, but if you don't know which exchange is best, we recommend three of the most reputable ones in the crypto
                    space.
                </p>

                <div className="ExchangesWrapper">
                    <div className="Image Binance" onClick={() => window.open("https://www.binance.com/")} />
                    <div className="Image Coinbase" onClick={() => window.open("https://www.coinbase.com/")} />
                    <div className="Image Kraken" onClick={() => window.open("https://www.kraken.com/")} />
                </div>

                <p>
                    Once you have everything set up with your exchange of choice and bought some ADA you will need now to transfer the ADA from your exchange to your own personal
                    wallet.
                </p>
            </div>
        );
    }

    renderSection2() {
        return (
            <div className="Section2Wrapper">
                <h1>Creating and trasfering to your wallet</h1>

                <p>
                    Having you Cardano on an exchange is much like having your FIAT currency in a traditional bank, it is not actually yours. The bank (or exchange) only promises
                    that the amount of your currency stored will be returned to you the moment you want to. To truly own your money you will have to store it in a crypto wallet.
                    Despite having the name of wallet, it is more like your own personal bank, it is where you store your assets and you are free to withdraw, exchange or do
                    anything you want with it. Unlike a traditional bank or exchange, you and only you are intire responsible for that money.
                </p>

                <p>
                    Each blockchain network will have it's own wallet, or various wallets will be able to connect to different blockchains. For the Cardano network, two major
                    wallets are recoomended.
                </p>

                <div className="WalletsWrapper">
                    <div className="WalletWrapper">
                        <div className="Image Daedalus" onClick={() => window.open("https://daedaluswallet.io/")} />
                        <p>Recommended for maximum security</p>
                    </div>
                    <div className="WalletWrapper">
                        <div className="Image Yoroi" onClick={() => window.open("https://yoroi-wallet.com/")} />
                        <p>Recommended for easiest and quickest setup</p>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="Step1MainWrapper">
                {this.renderSection1()}
                {this.renderSection2()}
                <div className="FinalWrapper">
                    <h2>
                        Once you've been able to transfer your funds to your wallet, head over to the{" "}
                        <em
                            onClick={() => {
                                this.props.history.push("/step2");
                            }}
                        >
                            staking step
                        </em>
                    </h2>
                </div>
            </div>
        );
    }
}

export default withRouter(Step1);
